import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Divider } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { NumberedList } from '../../../../general/components/numbered-list/NumberedList';
import { VERIFY_REVENUE_DOCS } from '../../../../paths';
import { RootState } from '../../../../store';
import { ChoiceContainer } from '../choice-container/choice-container';

const selector = ({
  documentRequirements: { requiredDocuments, loading: uploading, error: uploadError },
  nextStep: { loading: appLoading, error: appError },
}: RootState) => ({
  documents: requiredDocuments,
  loading: uploading || appLoading,
  error: uploadError ?? appError,
});

const DocsVerifyRevenueTile: FC = () => {
  const navigate = useNavigate();
  const handleDocsChoice = useCallback(() => {
    navigate(VERIFY_REVENUE_DOCS);
  }, [navigate]);

  const { documents } = useSelector(selector);

  const uploadDocumentTitle = <>Upload documents</>;

  const uploadDocumentSubtitle = (
    <>
      If you don&apos;t want to securely link to your account, you can still verify your revenue by uploading the
      required financial documents:
    </>
  );

  const documentNames = documents.map((document) => document.documentName);

  return (
    <ChoiceContainer
      icon={<CloudUploadOutlinedIcon />}
      title={uploadDocumentTitle}
      subtitle={uploadDocumentSubtitle}
      onChoice={handleDocsChoice}
    >
      <Divider flexItem />
      <NumberedList listValues={documentNames} />
    </ChoiceContainer>
  );
};

export { DocsVerifyRevenueTile };
